import { Breadcrumbs, Typography } from '@mui/material';
import { Route } from 'react-router-dom';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { toTitleCase } from '../../../util/stringUtil';
import useGetPipelinesByEmail from '../../../shared/hooks/useGetPipelinesByEmail';
import { useTranslation } from 'react-i18next';

const AppBreadcrumb = (): JSX.Element => {
  const { t } = useTranslation();

  const { data, error, isLoading } = useGetPipelinesByEmail();

  const breadcrumbMap = {
    algorithm: t('Algorithms'),
    results: t('Results'),
  };

  return (
    <Route>
      {({ location }) => {
        const getBreadcrumbNames = (): string[] => {
          const pathnames: string[] = location.pathname.split('/').filter((x: string) => x);

          const first = pathnames[0];

          if (pathnames[0] === 'pipeline') {
            if (error) {
              return [t('Pipeline'), t('Error')];
            }
            if (isLoading) {
              return [t('Pipeline'), t('Loading')];
            }
            if (data && pathnames.length > 1) {
              const names = data.filter(x => x.pid === pathnames[1]).map(x => x.pipeline.name);
              if (names) {
                return [t('Pipeline'), names[0]];
              }
            }
            return [t('Pipeline')];
          } else if (pathnames.length === 0) {
            return [t('Home')];
          } else if (first in breadcrumbMap) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            return [breadcrumbMap[first]];
          } else {
            return pathnames.map(toTitleCase);
          }
        };

        const pathnames = getBreadcrumbNames();

        return (
          <Breadcrumbs aria-label={'breadcrumb'} separator={<NavigateNextIcon fontSize={'small'} />}>
            {pathnames.map((x, i: number) => (
              <Typography key={i} color="text.primary">
                {x}
              </Typography>
            ))}
          </Breadcrumbs>
        );
      }}
    </Route>
  );
};

export default AppBreadcrumb;
